import React from "react";
import { PureComponent } from "react";
import { Alert } from "react-bootstrap";
import styles from './Message.module.css';

type MessageProps = {
  message: string | null,
  description: string | null,
  type: "success" | "danger" | "info" | undefined
}

export class Message extends PureComponent<MessageProps> {
  render() {
    return (
      this.props.message ?
        <Alert className={styles.root} style={{ margin: '20px 0', fontSize: '11px' }} variant={this.props.type}>
          <div className={styles.message}>{this.props.message}</div>
          { this.props.description &&
            <div className={styles.description} dangerouslySetInnerHTML={{__html: this.props.description}} /> }
        </Alert>
      : null
    );
  }
}

export default Message;
